module.exports = __webpack_public_path__ + "static/img/challenge-4.b201ae7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/characters/challenge-4.svg
// module id = XWMH
// module chunks = 1